import { createSlice } from "@reduxjs/toolkit";
import { getAllmanageSlotAction, getmanageSlotAction, insertUpdateSlotAction, SlotChangeStatusACTION, getAllExceptionSlotAction, insertUpdateManageExceptionAction } from "../../actions/slotManagementActions/manageSlotAction";
import { toast } from 'react-toastify';
import { Enums } from "../../../helper/constants/enums";

const INITIAL_STATE = {
    ManageSlot: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    ExceptionSlot: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    selectedManageSlot: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    insertUpdateManageSlot: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    insertUpdateManageException: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    deleteManageSlot: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    deleteManageException: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    }
};

const ManageSlotReducer = createSlice({
    name: "ManageSlot",
    initialState: INITIAL_STATE,
    reducers: {

        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetManageSlotDetailsState(state, action) {
            state.selectedManageSlot = INITIAL_STATE.selectedManageSlot;
            state.insertUpdateManageSlot = INITIAL_STATE.insertUpdateManageSlot;
            state.insertUpdateManageException = INITIAL_STATE.insertUpdateManageException;
        },
    },
    extraReducers: (builder) => {

        builder.addCase(getAllmanageSlotAction.fulfilled, (state, action) => {
            state.ManageSlot.data = action.payload.data;
            state.ManageSlot.apiMsg.status = action.meta.requestStatus;
            state.ManageSlot.apiMsg.message = "success";
        });
        builder.addCase(getAllmanageSlotAction.pending, (state, action) => {
            state.ManageSlot.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllmanageSlotAction.rejected, (state, action) => {
            state.ManageSlot.apiMsg.message = action.error.message;
            state.ManageSlot.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getAllExceptionSlotAction.fulfilled, (state, action) => {
            state.ExceptionSlot.data = action.payload.data;
            state.ExceptionSlot.apiMsg.status = action.meta.requestStatus;
            state.ExceptionSlot.apiMsg.message = "success";
        });
        builder.addCase(getAllExceptionSlotAction.pending, (state, action) => {
            state.ExceptionSlot.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllExceptionSlotAction.rejected, (state, action) => {
            state.ExceptionSlot.apiMsg.message = action.error.message;
            state.ExceptionSlot.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(getmanageSlotAction.fulfilled, (state, action) => {
            state.selectedManageSlot.data = action.payload.data;
            state.selectedManageSlot.apiMsg.status = action.meta.requestStatus;
            state.selectedManageSlot.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(getmanageSlotAction.pending, (state, action) => {
            state.selectedManageSlot.data = null;
            state.selectedManageSlot.apiMsg.message = action.meta.requestStatus;;
            state.selectedManageSlot.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getmanageSlotAction.rejected, (state, action) => {
            state.selectedManageSlot.apiMsg.message = action.error.message;
            state.selectedManageSlot.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(insertUpdateSlotAction.fulfilled, (state, action) => {
            if (action.meta.arg) {
                const newData = action.meta.arg;
                const payload = action.payload.data.data;
                const existingRecords = state.ManageSlot.data.records;
                const index = existingRecords
                    ? existingRecords.findIndex(record => record.slotID === newData.slotID)
                    : -1;

                if (!newData.slotID) {
                    newData.slotID = action.payload.data.data;
                }

                if (index !== -1) {
                    existingRecords[index] = {
                        ...existingRecords[index],
                        ...newData,
                    };
                } else {
                    if (
                        newData.CheckuserType == Enums.UserType.MasterAdmin ||
                        newData.CheckuserType == Enums.UserType.MasterAdminUser
                    ) {
                        if (newData.businessID == newData.filterBusinessID) {
                            existingRecords.push(newData);
                            state.ManageSlot.data.totalRecords =
                                state.ManageSlot.data.totalRecords + 1;
                        }
                    } else {
                        existingRecords.push(newData); state.ManageSlot.data.totalRecords = state.ManageSlot.data.totalRecords + 1;
                    }
                }
                state.ManageSlot.data.records = existingRecords;

                state.insertUpdateManageSlot.data = {
                    slotID: payload,
                    businessID: newData.businessID,
                    businessName: newData.businessName,
                    day: newData.day,
                    deliveryType: newData.deliveryType,
                    open: newData.open,
                    slotDetail: newData.slotDetail,
                };
            }

            state.insertUpdateManageSlot.apiMsg.status = action.meta.requestStatus;
            state.insertUpdateManageSlot.apiMsg.message = action.payload.message.message;
            toast.success(action.payload.message.message, {
                position: "bottom-center",
                toastId: "success",
            });
        });
        builder.addCase(insertUpdateSlotAction.pending, (state, action) => {
            state.insertUpdateManageSlot.apiMsg.status = action.meta.requestStatus;
        }
        );
        builder.addCase(insertUpdateSlotAction.rejected, (state, action) => {

            state.insertUpdateManageSlot.apiMsg.message = action.error.message;
            state.insertUpdateManageSlot.apiMsg.status = action.meta.requestStatus;

            toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                position: "bottom-center",
                toastId: "error"
            });
        }
        );



        builder.addCase(insertUpdateManageExceptionAction.fulfilled, (state, action) => {
            if (action.meta.arg) {
                const newData = action.meta.arg;
                const payload = action.payload.data.data;
                const existingRecords = state.ExceptionSlot.data.records;
                const index = existingRecords
                    ? existingRecords.findIndex(record => record.slotID === newData.slotID)
                    : -1;

                if (!newData.slotID) {
                    newData.slotID = action.payload.data.data;
                }

                if (index !== -1) {
                    existingRecords[index] = {
                        ...existingRecords[index],
                        ...newData,
                    };
                } else {
                    if (
                        newData.CheckuserType == Enums.UserType.MasterAdmin ||
                        newData.CheckuserType == Enums.UserType.MasterAdminUser
                    ) {
                        if (newData.businessID == newData.filterBusinessID) {
                            existingRecords.push(newData);
                            state.ExceptionSlot.data.totalRecords =
                                state.ExceptionSlot.data.totalRecords + 1;
                        }
                    } else {
                        existingRecords.push(newData); state.ExceptionSlot.data.totalRecords = state.ExceptionSlot.data.totalRecords + 1;
                    }
                }
                state.ExceptionSlot.data.records = existingRecords;

                state.insertUpdateManageException.data = {
                    slotID: payload,
                    businessID: newData.businessID,
                    businessName: newData.businessName,
                    day: newData.day,
                    deliveryType: newData.deliveryType,
                    open: newData.open,
                    slotDetail: newData.slotDetail,
                };
            }

            state.insertUpdateManageException.apiMsg.status = action.meta.requestStatus;
            state.insertUpdateManageException.apiMsg.message = action.payload.message.message;
            toast.success(action.payload.message.message, {
                position: "bottom-center",
                toastId: "success",
            });
        });
        builder.addCase(insertUpdateManageExceptionAction.pending, (state, action) => {
            state.insertUpdateManageException.apiMsg.status = action.meta.requestStatus;
        }
        );
        builder.addCase(insertUpdateManageExceptionAction.rejected, (state, action) => {

            state.insertUpdateManageException.apiMsg.message = action.error.message;
            state.insertUpdateManageException.apiMsg.status = action.meta.requestStatus;

            toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                position: "bottom-center",
                toastId: "error"
            });
        }
        );


        builder.addCase(SlotChangeStatusACTION.fulfilled, (state, action) => {
            if (action.meta.arg.StatusType === Enums.ChangeStatus.Delete) {
                if (action.meta.arg.isException == true) {

                    const existingRecords = state.ExceptionSlot.data.records;
                    const roleIdToDelete = action.meta.arg.Id;
                    const updatedRecords = existingRecords.filter(record => record.slotID !== roleIdToDelete);
                    state.ExceptionSlot.data.records = updatedRecords;
                    state.ExceptionSlot.data.totalRecords = state.ExceptionSlot.data.totalRecords - 1;
                    state.deleteManageException.apiMsg.status = action.meta.requestStatus;
                    state.deleteManageException.apiMsg.message = action.payload.message.message;

                } else if (action.meta.arg.isException == false) {

                    const existingRecords = state.ManageSlot.data.records;
                    const roleIdToDelete = action.meta.arg.Id;
                    const updatedRecords = existingRecords.filter(record => record.slotID !== roleIdToDelete);
                    state.ManageSlot.data.records = updatedRecords;
                    state.ManageSlot.data.totalRecords = state.ManageSlot.data.totalRecords - 1;
                    state.deleteManageSlot.apiMsg.status = action.meta.requestStatus;
                    state.deleteManageSlot.apiMsg.message = action.payload.message.message;
                }

            }

        });
        builder.addCase(SlotChangeStatusACTION.pending, (state, action) => {
            if (action.meta.arg.StatusType === Enums.ChangeStatus.Delete) {
                if (action.meta.arg.isException == true) {
                    state.deleteManageException.apiMsg.status = action.meta.requestStatus;
                } else if (action.meta.arg.isException == false) {
                    state.deleteManageSlot.apiMsg.status = action.meta.requestStatus;
                }
            }

        });
        builder.addCase(SlotChangeStatusACTION.rejected, (state, action) => {
            if (action.meta.arg.StatusType === Enums.ChangeStatus.Delete) {
                if (action.meta.arg.isException == true) {
                    state.deleteManageException.apiMsg.message = action.error.message;
                    state.deleteManageException.apiMsg.status = action.meta.requestStatus;
                } else if (action.meta.arg.isException == false) {
                    state.deleteManageSlot.apiMsg.message = action.error.message;
                    state.deleteManageSlot.apiMsg.status = action.meta.requestStatus;
                }
            }

        });
    }
});

export const { RESET, ResetManageSlotDetailsState } = ManageSlotReducer.actions;
export default ManageSlotReducer.reducer;